import InfoIcon from "@mui/icons-material/InfoOutlined";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { NumericFormat } from "react-number-format";
import { Masked } from "work/_shared/masked-fields";
import WorkAgreement, { WorkAgreementFieldCategory } from "work/work-agreements/work-agreement";

const ComponentContainer = styled("div")(
  ({ theme }) => ({
    margin: theme.spacing(2, 0, 4, 0),
  }));
const HelperText = styled(Typography)(
  ({ theme }) => ({
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  }));


const discountDescription =
  "You can share the AttorneyHub fees you incur from a project by establishing " +
  'an agreed upon "discount" from your vendor. 2.912% is the value to cover the cost.';

type DiscountTabProps = {
  activeTab: WorkAgreementFieldCategory;
  workAgreement: WorkAgreement;
};

export default function DiscountTab(props: Readonly<DiscountTabProps>) {
  const {
    activeTab,
    workAgreement
  } = props;

  const discount = Masked.isMasked(workAgreement.discount)
    ? 0
    : workAgreement.discount?.value ?? 0;

  if (activeTab !== WorkAgreementFieldCategory.Discount) return null;
  if (Masked.isMasked(workAgreement.discount)) return "You do not have permission to view the discount.";
  return (
    <ComponentContainer>
      <NumericFormat
        name="discount"
        label="Discount"
        customInput={TextField}
        allowNegative={false}
        value={Number(discount * 100)}
        suffix="%"
        type="text"
        thousandSeparator={false}
        decimalScale={2}
        disabled={true}
      />
      <HelperText>
        Discounts help cover subscription costs.
        <Tooltip
          disableFocusListener
          title={discountDescription}
          placement="right"
          arrow
        >
          <IconButton size="small">
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </HelperText>
    </ComponentContainer>
  );
}
